import React from 'react';
import { Input } from 'reactstrap';
import {
    TermForm,
    GeneralDeferredPaymentsInformation,
} from '../../../../../../slices/marketplace/loi-form/term-form';
import './TermsFormGeneralDeferredPaymentsBlock.scss';

export interface TermsFormGeneralDeferredPaymentsBlockProps {
    termForm: TermForm;
    readOnly?: boolean;
    onChange?: (form: TermForm) => void;
    errors?: Set<string>;
}

export const TermsFormGeneralDeferredPaymentsBlock: React.FC<
    TermsFormGeneralDeferredPaymentsBlockProps
> = ({ termForm, readOnly = false, onChange, errors }) => {
    const info: GeneralDeferredPaymentsInformation | null | undefined =
        termForm.generalDeferredPaymentsInformation;

    const update = (patch: Partial<GeneralDeferredPaymentsInformation>) => {
        onChange?.({
            ...termForm,
            generalDeferredPaymentsInformation: {
                ...(info ?? {}),
                ...patch,
            },
        });
    };

    return (
        <div className="terms-form-detail-block terms-form-section-underlined terms-form-general-deferred-payments-block">
            <div className="terms-form-block-name">General Deferred Payments Information</div>
            <div className="terms-form-form-content">
                <div className="terms-form-general-deferred-payments-row">
                    <div className="terms-form-general-deferred-payments-field">
                        <span className="terms-form-general-deferred-payments-label">
                            Payment Obligor
                        </span>
                        <div className="terms-form-general-deferred-payments-value">
                            <Input
                                type="text"
                                value={info?.paymentObligor ?? ''}
                                disabled={readOnly}
                                onChange={(e) =>
                                    update({ paymentObligor: e.target.value || null })
                                }
                                className="form-control loi-form-input"
                                aria-label="Payment Obligor"
                                invalid={errors?.has('paymentObligor')}
                            />
                        </div>
                    </div>
                    <div className="terms-form-general-deferred-payments-field">
                        <span className="terms-form-general-deferred-payments-label">
                            Assets Held by Obligor
                        </span>
                        <div className="terms-form-general-deferred-payments-value">
                            <Input
                                type="text"
                                value={info?.assetsHeldByObligor ?? ''}
                                disabled={readOnly}
                                onChange={(e) =>
                                    update({ assetsHeldByObligor: e.target.value || null })
                                }
                                className="form-control loi-form-input"
                                aria-label="Assets Held by Obligor"
                                invalid={errors?.has('assetsHeldByObligor')}
                            />
                        </div>
                    </div>
                    <div className="terms-form-general-deferred-payments-field">
                        <span className="terms-form-general-deferred-payments-label">
                            Interest Applied to Deferred Payments
                        </span>
                        <div className="terms-form-general-deferred-payments-value">
                            <Input
                                type="text"
                                value={info?.interestAppliedToDeferredPayments ?? ''}
                                disabled={readOnly}
                                onChange={(e) =>
                                    update({
                                        interestAppliedToDeferredPayments:
                                            e.target.value || null,
                                    })
                                }
                                className="form-control loi-form-input"
                                aria-label="Interest Applied to Deferred Payments"
                                invalid={errors?.has('interestAppliedToDeferredPayments')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
